import React from 'react'

import * as Form from 'modules/plan/components/Form'
import * as styles from './styles.module.scss'
import * as Layout from '../Layout/Section'

/**
 */
export const SelectPropertyType = ({ onChange }) => (
  <Layout.Container>
    <Layout.Title>Room Size</Layout.Title>
    <Layout.Description>お部屋のサイズをお選びください。</Layout.Description>
    <Layout.Content>
      <Form.Fields.PropertyType />
    </Layout.Content>
  </Layout.Container>
)
